/* eslint-disable no-new */
export default {
    /**
     * @override
     */
    setFullScreen({ commit }, isFullScreen) {
        new Promise(resolve => {
            commit('SET_FULLSCREEN', isFullScreen);
            resolve();
        });
    }
};
